var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTweetLikes(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 11.7068L7.25681 11.5482C7.0526 11.416 2.25747 8.24394 2.25747 5.3884C2.22901 4.99345 2.28208 4.59687 2.41338 4.22331C2.54467 3.84974 2.75138 3.50716 3.02067 3.21686C3.28996 2.92656 3.61608 2.69474 3.97875 2.5358C4.34142 2.37687 4.7329 2.29421 5.12887 2.29297C5.5856 2.29782 6.03549 2.40458 6.4457 2.60546C6.85592 2.80633 7.21611 3.09626 7.5 3.45408C7.78399 3.09621 8.1443 2.80626 8.55463 2.60538C8.96496 2.4045 9.41496 2.29777 9.8718 2.29297C10.2677 2.2943 10.6591 2.37702 11.0217 2.536C11.3843 2.69498 11.7103 2.92681 11.9796 3.2171C12.2488 3.50739 12.4554 3.84994 12.5867 4.22346C12.7179 4.59698 12.771 4.99351 12.7425 5.3884C12.7425 8.24592 7.9474 11.4147 7.74319 11.5482L7.5 11.7068Z",
    stroke: "var(--mainColor)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTweetLikes);
export default __webpack_public_path__ + "static/media/tweetLikes.f0f085b7a2fb120cc2d6f3cb98cc1ea4.svg";
export { ForwardRef as ReactComponent };